
export const LaserSprite = (
  <>
    <path
      fill="#1b1464"
      d="M103.89 78.91A8.36 8.36 0 0196.28 74L84.72 48.55c-.09-.16-.18-.33-.26-.5l-2-4.48h-1.41l3.79 12.92H76.2a7.34 7.34 0 01-7-5.22l-2.25-7.7H19.51v-9H11v2.2H0V14.19h11v2.21h8.48v-9h17.25V0h62.93v7.42h6.09a10 10 0 0110 10v16.19a10 10 0 01-4.93 8.6l9.91 21.27a8.28 8.28 0 01.19 6.53 8.37 8.37 0 01-4.68 4.66L107 78.31a8.45 8.45 0 01-3.11.6zm-8.47-23.73l7.24 15.94a1.38 1.38 0 001.75.68l9.21-3.64a1.24 1.24 0 00.75-.74 1.21 1.21 0 000-1l-11.6-24.88 3-1.4v-3.57a3 3 0 003-3v-16.2a3 3 0 00-3-3H92.66V7H43.73v7.42H26.51v9H7v4.19h19.51v9H87l3.63 8h2.83a5.49 5.49 0 013.89 1.6 5.43 5.43 0 011.63 3.9 5.49 5.49 0 01-3.56 5.07z"
    />
    <path
      fill="#0071bc"
      d="M94.85 48.64a2 2 0 01-1.43 3.41h-3.27l2.1 4.62H101a2.08 2.08 0 011.43.58 2 2 0 01-1.43 3.42h-6.94l2.1 4.61h12.06a2 2 0 011.43.59 2 2 0 01.59 1.41 2 2 0 01-2 2H98l1.49 3.29a4.9 4.9 0 006.24 2.49l9.2-3.64a4.79 4.79 0 002.59-6.42l-11.59-24.93H84.71l3 6.53a2.47 2.47 0 002.26 1.46h3.48a2 2 0 011.4.58z"
    />
    <path
      fill="#ffc04d"
      d="M96.16 65.28l1.82 4h10.24a2 2 0 002-2 2 2 0 00-.59-1.41 2 2 0 00-1.43-.59zM92.25 56.67l1.81 4H101a2 2 0 001.43-3.42 2.08 2.08 0 00-1.43-.58z"
    />
    <path
      fill="#a4b0b3"
      d="M76.2 53h4l-3.82-12.93h-6.82l3 10.21A3.79 3.79 0 0076.2 53z"
    />
    <path
      fill="#ffc04d"
      d="M63.7 24.47v15.6h42.05a6.46 6.46 0 006.46-6.46V17.37a6.46 6.46 0 00-6.46-6.45H80.16l-9.47 13.55z"
    />
    <path fill="#0071bc" d="M23.01 24.47H63.7V40.07H23.01z" />
    <path
      fill="#4aaf6c"
      d="M23.01 10.92L23.01 24.47 70.69 24.47 80.16 10.92 23.01 10.92z"
    />
    <path fill="#a4b0b3" d="M40.23 3.5H96.16V10.92H40.23z" />
    <path fill="#a4b0b3" d="M7.53 19.9H23.01V31.089999999999996H7.53z" />
    <path fill="#bfcdd0" d="M3.5 17.69H7.53V33.29H3.5z" />
    <path
      fill="#f45648"
      d="M83.68 25.35a1.76 1.76 0 101.75-1.76 1.75 1.75 0 00-1.75 1.76z"
    />
    <circle cx="97" cy="25.35" r="4.7" fill="#f45648" />
    <path fill="none" d="M0 0H164.91V78.91H0z" />
  </>
);

